// Phase 4: 司令塔ミッションの gemma 参考意見（委任先の当たり付け）キャッシュ。
// classify-cache.ts と同じ module-level 保持（アプリ稼働中のみ・永続化しない）。
// 司令塔を開いただけでは gemma を呼ばない: マウント時はここの読み出しのみ、
// 新規呼び出しは「AI参考」ボタン起点（完了条件5）。
import type { InboxSuggestion } from "./tauri";

export type MissionAdvice = Record<string, InboxSuggestion>;

/** 未完了ミッションタスクから安定キーを作る（id と更新時刻、並び非依存） */
export function missionAdviceKey(items: Array<{ id: string; updatedAt: string }>): string {
  if (items.length === 0) return "__empty__";
  return items
    .map((t) => `${t.id}:${t.updatedAt}`)
    .sort()
    .join("|");
}

const cache = new Map<string, MissionAdvice>();

export function getCachedAdvice(key: string): MissionAdvice | undefined {
  return cache.get(key);
}

export function setCachedAdvice(key: string, advice: MissionAdvice): void {
  cache.set(key, advice);
}
